module.exports = __webpack_public_path__ + "img/i_reply_like_off.15bbf26e.svg";